import _ from 'underscore';
import constants from '../constants/index';
import normalize from '../lib/normalize';

const selectParticipants = (newState, propName, selected, ids) => {
	newState = Object.assign({}, newState);
	if(selected) {
		newState[propName] = _.uniq(newState[propName].concat(ids));
	}
	else {
		newState[propName] = _.without.apply(_, [newState[propName]].concat(ids));
	}

	return newState;
};

const unSelectParticipants = (newState, action) => {
	newState = Object.assign({}, newState);
	newState.selected = [];
	newState.selectedGroups = [];
	return newState;
};

const selectParticipantsGroup = (participantName, newState, action) => {
	
	if(participantName !== action.payload.type) { return newState; }

	let group = action.payload.group;
	let ids = group.items.map(item => item.id);
	let selected = action.payload.selected;

	newState = Object.assign({}, newState);

	if(selected) {
		newState.selectedGroups = newState.selectedGroups.concat([group.id]);
	}
	else {
		newState.selectedGroups = _.without(newState.selectedGroups, group.id);
	}

	return selectParticipants(newState, 'selected', selected, ids);
};

const participantsReducer = participantName => (state, action) => {
	let participantConstantName = participantName.toUpperCase();

	let newState = state || normalize({
		selectedGroups: [],
		selected: [],
		inspected: []
	});

	switch(action.type) {
		case constants[`REQUEST_${participantConstantName}S_SUCCESS`]:
			newState = normalize(state, action.payload.participants);
			break;

		case constants[`SELECT_${participantConstantName}`]:
			newState = selectParticipants(
				newState, 
				'selected', 
				action.payload.selected, 
				[action.payload.id]
			);
			break;

		case constants[`SELECT_${participantConstantName}S`]:
			newState = selectParticipants(
				newState, 
				'selected', 
				action.payload.selected, 
				action.payload.ids
			);
			break;

		case constants.SELECT_PARTICIPANTS_GROUP:
			newState = selectParticipantsGroup(participantName, newState, action);
			break;

		case constants[`UNSELECT_${participantConstantName}S`]:
			newState = unSelectParticipants(newState, action);
			break;

		case constants.SELECT_VIEWER_SUBCOLUMN:
			newState = selectParticipants(
				newState, 
				'inspected', 
				action.payload.selected, 
				[action.payload.value]
			);
			break;

		default:
	}
	return newState;
};

export default function forParticipant(participantName) {
	return participantsReducer(participantName);
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/participants_reducer.js
 **/